import * as React from "react";
import { Modal,Button,Input,Radio,Upload,Icon} from "antd";
import { connect } from "react-redux";
const { TextArea } = Input;
const Dragger = Upload.Dragger;
interface ISendProps {
  id:any;
  getQNConfig:any;
  email:any;
  goTime:any;
  skuName:any;
  contact:any;
  sendMail:any;
  getOrderDetails:any;
}

// 确认函
class Send extends React.Component<ISendProps, any> {
  state = {
    visible:false,
    token:'',
    url:'',
    name:'',
    upload:false,
    email:'',
    emailnew:'',
    title:'',
    files:[],
    iconLoading: false,
  };
  constructor(props: ISendProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (prevState.email != nextProps.email) {
      this.setState({
        email:this.props.email,
        emailnew:this.props.email,
        title:'【懒猫订单确认函】 '+this.props.contact+this.props.goTime+this.props.skuName,
      });
      return false;
    }
    return true;
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
    this.getToken(); 
  }

  getToken= () => {
    const param: any = {
    }; 
    this.props.getQNConfig({
      ...param,
      callback: (data) => {
        this.setState({
          token:data.token,
          url:data.url,
        }); 
      //console.log(data);     
      }
     });     
  }

  onChange =(value) => {
    this.setState({
       text:value.target.value
    })     
  }
  
  onSelect = event =>{
    if(event.target.value == 'b'){
      this.setState({
        upload:true
       })   
       this.getToken();   
     }else{
      this.setState({
        upload:false
       })         
     }
  }

  upload = event => {
     console.log(event); 
     let data = event.fileList;
     const listItems = data.map((item) =>{
      if(item.response){
        return({
          'name':item.name,
          'file':this.state.url+'/'+item.response['key'],
          'type':item.type,
        });
      }else{
        return false;
      }
     }); 
     this.setState({
      files:listItems
     }) 
     console.log(listItems);  
  }

  change = (name,value) =>{
    if(name == 'email'){
      this.setState({
        emailnew:value.target.value
       })       
    }else{
      this.setState({
        title:value.target.value
       })       
    }
  } 
  sendMail = () =>{
    this.setState({ iconLoading: true });
    const param: any = {
      id: this.props.id,
      files:this.state.files,
      email:this.state.email,
      title:this.state.title,
      upload:this.state.upload, 
    }; 
    this.props.sendMail({
      ...param,
      callback: (data) => {
        this.handleCancel();
        this.setState({ iconLoading: false });
        const params: any = {
          id: this.props.id
        }; 
        this.props.getOrderDetails({
          ...params,
          callback: () => {
          }
         });                          
      }
     }); 
  }
  render() {
    const data = {
       'token':this.state.token,
    };
    return (
      <React.Fragment>
      <Button onClick={this.show.bind(this,this.props.id)}>发送确认函</Button> 
      <Modal maskClosable={false} onCancel={this.handleCancel} title="发送确认函"  visible={this.state.visible} footer={null} width="auto" centered={true}>
          <div className="wechat-push">
                <div className="hang"><label className="f">收件邮箱：</label><span><Input onChange={this.change.bind(this,'email')} value={this.state.emailnew} className="messge" /></span></div>
                <div className="hang"><label className="f">邮件标题：</label><span><TextArea value={this.state.title} onChange={this.change.bind(this,'title')}  rows={3} /></span></div>
                <div className="hang hradio"><label className="f">附件：</label><span>     
                <Radio.Group defaultValue="a" buttonStyle="solid" onChange={this.onSelect}>
                  <Radio.Button value="a">一键发函</Radio.Button>
                  <Radio.Button value="b">自定义附件</Radio.Button>
                </Radio.Group>
                </span></div>
                {this.state.upload ?  <div className="upload"><span><Dragger onChange={this.upload} action="//upload.qiniup.com" name='file' data={data} ><p className="ant-upload-drag-icon"><Icon type="inbox" /></p></Dragger></span></div> : ''}
          </div>
          <div className="down-confirmation">
          <Button type="primary" onClick={this.sendMail} loading={this.state.iconLoading} >发送确认函</Button>
           </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  skuName: state.orderDetails.skuName,
  goTime:state.orderDetails.goTime,
  email:state.orderDetails.email,
  contact:state.orderDetails.contact,
  taoAccount:state.orderDetails.taoAccount,
});

const mapDispatch = dispatch => {
  return {
    getQNConfig: dispatch.orderDetails.getQNConfig,
    sendMail:dispatch.orderDetails.sendMail,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Send);
